import { render, staticRenderFns } from "./EmojiDropdown.vue?vue&type=template&id=38a92d3e&scoped=true"
import script from "./EmojiDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./EmojiDropdown.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EmojiDropdown.vue?vue&type=style&index=0&id=38a92d3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a92d3e",
  null
  
)

export default component.exports